import { useMe } from '@/queries/me/useMe';
import { useAgency } from './useAgency';

export function useCurrentAgency() {
  const { data: me } = useMe();
  return useAgency(me?.agency?.id);
}
